const usar = (valor, porDefecto) =>
  typeof valor === 'string' && valor.trim() ? valor.trim() : porDefecto;

export const UNIDAD_TRABAJO_DEFAULT = Object.freeze({
  codigoUnidadCantidad: null,
  unidadCantidad: 'Metros',
  abreviaturaUnidadCantidad: 'm',
  codigoUnidadTiempo: null,
  unidadTiempo: 'Minutos',
  abreviaturaUnidadTiempo: 'min',
});

/**
 *
 * @param {object|null|undefined} unidadTrabajo
 * @returns {{codigoUnidadCantidad: number|null, unidadCantidad: string, abreviaturaUnidadCantidad: string, codigoUnidadTiempo: number|null, unidadTiempo: string, abreviaturaUnidadTiempo: string}}
 */
export function completarUnidadTrabajo(unidadTrabajo) {
  return {
    codigoUnidadCantidad: unidadTrabajo?.codigoUnidadCantidad ?? null,
    unidadCantidad: usar(unidadTrabajo?.unidadCantidad, UNIDAD_TRABAJO_DEFAULT.unidadCantidad),
    abreviaturaUnidadCantidad: usar(
      unidadTrabajo?.abreviaturaUnidadCantidad,
      UNIDAD_TRABAJO_DEFAULT.abreviaturaUnidadCantidad,
    ),
    codigoUnidadTiempo: unidadTrabajo?.codigoUnidadTiempo ?? null,
    unidadTiempo: usar(unidadTrabajo?.unidadTiempo, UNIDAD_TRABAJO_DEFAULT.unidadTiempo),
    abreviaturaUnidadTiempo: usar(
      unidadTrabajo?.abreviaturaUnidadTiempo,
      UNIDAD_TRABAJO_DEFAULT.abreviaturaUnidadTiempo,
    ),
  };
}

/**
 * Abbreviation of the unit in which a process' fixed merma is configured:
 * its own unit (`unidadMermaFija`), else the resource work unit, else meters.
 * @param {object|null|undefined} proceso
 * @returns {string}
 */
export function resolverAbreviaturaMermaFija(proceso) {
  return (
    usar(proceso?.unidadMermaFija?.abreviatura, '') ||
    completarUnidadTrabajo(proceso?.unidadTrabajo).abreviaturaUnidadCantidad
  );
}

/**
 * Abbreviation of the resource work unit (unit of the engine's merma values).
 * @param {object|null|undefined} proceso
 * @returns {string}
 */
export function resolverAbreviaturaUnidadRecurso(proceso) {
  return completarUnidadTrabajo(proceso?.unidadTrabajo).abreviaturaUnidadCantidad;
}
